import React from 'react'
import cn from 'classnames'
import SUI from 'shared/components/ui/SUI'
import { styles } from './styles'

export default function LoginLayout({ className, children }) {
  return (
    <SUI transparent={false}>
      <div css={styles.login} className={cn('grui flex-center', className)}>
        <div css={styles.container} className="grui w-100">
          <div className="grui py-14">{children}</div>
        </div>
      </div>
    </SUI>
  )
}
